import Accordion from "@ui/accordion";
import Image from "@ui/image";
import SectionTitle from "@ui/section-title";
import { Col, Container, Row } from "@ui/wrapper";
import {
    ImageType,
    ItemType,
    SectionTitleType,
    VideoButtonType,
} from "@utils/types";
import PropTypes from "prop-types";
import React from "react";
import { ImageWrapper, SectionWrap, StyledImageContainer } from "./style";

const FaqArea = ({ data, space }) => {
    return (
        <SectionWrap $space={space}>
            <Container>
                {data?.section_title && (
                    <SectionTitle mb="44px" {...data.section_title} />
                )}

                <Row>
                    <Col lg={6}>
                        {data?.items && (
                            <Accordion
                                disableDefaultActive
                                layout={2}
                                data={data.items}
                            />
                        )}
                    </Col>
                    <Col lg={6} mt={["20px", null, null, 0]}>
                        {data?.images?.[0] && (
                            <StyledImageContainer>
                                <ImageWrapper>
                                    <Image {...data.images[0]} />
                                </ImageWrapper>
                            </StyledImageContainer>
                        )}
                    </Col>
                </Row>
            </Container>
        </SectionWrap>
    );
};

FaqArea.propTypes = {
    data: PropTypes.shape({
        section_title: PropTypes.shape(SectionTitleType),
        items: PropTypes.arrayOf(PropTypes.shape(ItemType)),
        images: PropTypes.arrayOf(PropTypes.shape(ImageType)),
        video_button: PropTypes.shape(VideoButtonType),
    }),
    space: PropTypes.oneOf([1, 2]),
};

FaqArea.defaultProps = {
    space: 1,
};

export default FaqArea;
